import type { AddProductsToFavouriteListInput } from '../../request/backendApi/favourites/addProductsToFavouriteList';
import { requestAddProductsToFavouriteList } from '../../request/backendApi/favourites/addProductsToFavouriteList';

export const addProductsToFavouriteList = (input: AddProductsToFavouriteListInput) =>
  requestAddProductsToFavouriteList(input);
